module.exports = __webpack_public_path__ + "static/media/birdbig.54acd3bc.png";